import m from "../../../../geodata/es2015/region/usa/ilHigh";
window.am4geodata_region_usa_ilHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/ilHigh.js
// module id = null
// module chunks = 